let initCustomSelect = function () {

  var x, i, j, l, ll, selElmnt, a, b, c;
  /* Look for any elements with the class "custom-select": */
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    if(x[i].querySelector('.select-selected') != null && x[i].querySelector('.select-selected').innerHTML.length > 0) {
      continue;
    }
    else if(x[i].querySelector('.select-selected') != null && x[i].querySelector('.select-selected').innerHTML.length < 1) {
      x[i].querySelector('.select-selected').remove();
      x[i].querySelector('.select-items').remove();
    }
    //if(x[i].querySelector('.select-selected') != null) continue;
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /* For each element, create a new DIV that will act as the selected item: */
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    let skip = false;
    if(typeof selElmnt.options[selElmnt.selectedIndex] == "undefined") {
      skip = true;
      a.innerHTML = '';
    }
    else {
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    }
    x[i].appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 0; j < ll; j++) {
      /* For each option in the original select element,
      create a new DIV that will act as an option item: */
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.dataset.val = selElmnt.options[j].innerHTML;

      c.addEventListener("click", function(e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
        s.dispatchEvent(new Event("change"))
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);


    let cs = x[i];
    let csItems = cs.querySelectorAll('.select-items div');
    let csVal = cs.querySelector('.select-selected').innerText;

    csItems.forEach(function(el) {
      if(el.dataset.val == csVal) {
        el.classList.add('same-as-selected')
      }
    });


    a.addEventListener("click", function(e) {
      /* When the select box is clicked, close any other select boxes,
      and open/close the current select box: */
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");

      if(this.classList.contains('select-arrow-active')) {
        document.querySelector('body').classList.add('custom-select-open');
      }
    });

    x[i].classList.add('initialized')
  }

  function closeAllSelect(elmnt=null, removeBodyClass=true) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i) && typeof x[i] != "undefined") {
        x[i].classList.add("select-hide");
      }
    }
    if(removeBodyClass) document.querySelector('body').classList.remove('custom-select-open');
  }

  /* If the user clicks anywhere outside the select box,
  then close all select boxes: */
  document.addEventListener("click", function(e) {
    let el = e.target;
    if(document.querySelector('body').classList.contains('custom-select-open') && !el.classList.contains('custom-select') && el.closest('.custom-select') == null) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeAllSelect();
    }

    if(!el.classList.contains('custom-select') && el.closest('.custom-select') == null) {
      closeAllSelect();
    }

  })

}

initCustomSelect();